// extracted by mini-css-extract-plugin
module.exports = {"redBox":"red-box-module--redBox--1ap5u","lobsterEat":"red-box-module--lobsterEat--3GaVX"};